import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandingPreview from './BrandingPreview';

interface TemplatePreviewModalContentProps {
  branding: any;
  onClose: () => void;
}

const TemplatePreviewModalContent: React.FC<TemplatePreviewModalContentProps> = ({
  branding,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-[90vw] max-w-5xl mx-auto">
      <div className="p-6 bg-gray-100 dark:bg-gray-800 max-h-[80vh] overflow-y-auto">
        <div className="max-w-4xl mx-auto">
          <BrandingPreview branding={branding} />
        </div>
      </div>
    </div>
  );
};

export default TemplatePreviewModalContent;
